import { z } from 'zod';

// Schemas (source of truth)
export const organizationSchema = z.object({
	organizationId: z.string(),
	organizationNick: z.string(),
});

// Types (derived from schemas)
export type IOrganization = z.infer<typeof organizationSchema>;
